// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1-aQ6","bigColWidth":"Table_bigColWidth__1nKZB","biggerColWidth":"Table_biggerColWidth__163w-","row":"Table_row__7BzF9","col":"Table_col__1aAuz"};